// extracted by mini-css-extract-plugin
module.exports = {"CountrySearch":"CountrySearch_CountrySearch__1JgHu","Search":"CountrySearch_Search__2mMYU"};